import React from "react";
import { AntdTerciaryButton } from "./styles";

export default function TerciaryButton({ ...props }) {
	return <AntdTerciaryButton {...props} />;
}
